<template>
    <div id="bene-aud-bt-postcode-container">
        <f7-list form class="form-group" v-if="showFormSet.kaasiDetails">
            <f7-list-input
                input-id     ="kaasiPostcode"
                name         ="kaasiPostcode"
                type         ="text"

                :label       ="$t('beneficiary-postcode')"
                :placeholder ="$t('beneficiary-postcode')"
                :value       ="postcode"
                @change      ="setPostcode($event.target.value); validateNumberInput($event.target)"

                autocomplete ="off"
                maxlength    ="15"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { check } from '@/plugins/helper';
    export default {
        props: {
        },
        mounted() {
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'postcode',
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setPostcode',
                'setIsFormInputValid',
            ]),

            validateNumberInput(inputEl){
                let isValidInput = false
                if(inputEl.value.trim() == ""){
                    isValidInput = true
                }else{
                    isValidInput = check.validPattern("number", inputEl.value);
                }
                
                if(!isValidInput){
                    this.setInputState(inputEl.id, this.$t('beneficiary-postcode-numerical-format'))
                    this.setIsFormInputValid(false);
                }else{
                    if(inputEl.value.trim() == ""){
                        this.setInputState(inputEl.id, true)
                    }else{
                        this.validateInput(inputEl);
                    }
                }
            },

            validateInput(inputEl){
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>